import { Button } from "@mui/material";
import { useMediaQuery } from "@mui/material";
import { ReactComponent as Arrow } from "../../../assets/Icons/arrow.svg";
import { useLocation, useNavigate } from "react-router-dom";

import React from "react";

type Props = {
  width?: string;
  text: string;
  link?: string;
  isLink?: boolean;
  isDownload?: boolean;
};

const ButtonLearn = ({ text }: Props) => {
  const navigate = useNavigate();

  const handleClick = () => {
    const encodedText = encodeURIComponent(text).toUpperCase();

    const element = document.getElementById(encodedText);
    if (element) {
      element.scrollIntoView({ behavior: "smooth" });
    } else {
      navigate(`/${text}`);
    }
  };
  const location = useLocation();
  const isYoga = location.pathname === "/yogaspace";
  const isTabletOrMobile = useMediaQuery("(max-width:1024px)");

  return (
    <Button
      onClick={handleClick}
      sx={{
        "& .MuiButton-endIcon": {
          marginLeft: "0.5vw", // This removes the margin from the end icon
          marginRight: 0,
          paddingTop: "0.15vw",
          color: "white",
        },
        borderRadius: "50px",
        fontFamily: "degular",
        textTransform: "none",
        pointerEvents: "auto",
        fontWeight: isYoga ? "500" : "500",
        padding: "5px 20px",
        fontSize: isTabletOrMobile ? "1.7vw" : undefined,
        border: "1px solid white",
        color: "white",
        letterSpacing: "0.5px",
      }}
      variant="outlined"
    >
      {text || "Write Us"}
    </Button>
  );
};

export default ButtonLearn;
